export default from './BuyerRequestPage';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/index.js